// create a skeleton component for server-setting-page.tsx using tailwindcss like email-template-skeleton.tsx
export default function ServerSettingSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="space-y-6 max-w-3xl py-8 text-left">
        {/* Google Credentials Upload Form */}
        <div className="rounded-md bg-gray-50 p-4 md:p-6">
          <div className="mb-4">
            <div className="h-5 w-48 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 w-full bg-gray-200 rounded"></div>
            <div className="h-4 w-32 bg-gray-200 rounded mt-2"></div>
          </div>
          <div className="mt-6 flex justify-end gap-4">
            <div className="h-10 w-24 bg-gray-200 rounded"></div>
            <div className="h-10 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>

        {/* Server Setting Form */}
        <div className="rounded-md bg-gray-50 p-4 md:p-6 mt-6">
          <div className="mb-4">
            <div className="h-5 w-40 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 w-full bg-gray-200 rounded"></div>
          </div>
          <div className="mb-4">
            <div className="h-5 w-36 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 w-full bg-gray-200 rounded"></div>
          </div>
          <div className="mt-6 flex justify-end">
            <div className="h-10 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
